export default "<spec-app-type9-specials-table #table [clickHandler]=\"clickHandler\" [allowCreate]=\"true\"></spec-app-type9-specials-table>\n";